import React from 'react';
import { string, array } from 'prop-types';

import styles from './OfferBlock.css';

const OfferBlock = ({ title, items }) => (
  <div className={styles.offer}>
    <p className={styles.title}>{title}</p>
    <ul className={styles.itemList}>
      {items.map((item, i) => <li className={styles.item} key={`item-offer-${i}`}>{item}</li>)}
    </ul>
  </div>
);

OfferBlock.propTypes = {
  title: string.isRequired,
  items: array
};

OfferBlock.displayName = 'OfferBlock';

export default OfferBlock;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/AdvantagesBanner/OfferBlock/OfferBlock.js